/* mobile-experience.js — premium motion layer for phones only.
   Additive & safe: if anything fails, the page is untouched and fully visible. */
(function () {
  'use strict';
  try {
    var mqMobile = window.matchMedia('(max-width: 749px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!mqMobile.matches || reduce) return;

    var root = document.documentElement;
    root.classList.add('m-motion');

    var ready = function (fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    };

    ready(function () {
      /* ---------- 1) Scroll progress bar ---------- */
      var bar = document.createElement('div');
      bar.className = 'm-progress';
      document.body.appendChild(bar);
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var h = document.documentElement.scrollHeight - window.innerHeight;
          var p = h > 0 ? Math.min(1, window.scrollY / h) : 0;
          bar.style.transform = 'scaleX(' + p + ')';
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      /* ---------- 2) Scroll reveals with stagger ---------- */
      var revealTargets = [
        ['.lh-kicker', ''],
        ['.lh-title', ''],
        ['.lh-text', ''],
        ['.lh-head > .lh-link', ''],
        ['.luxury-trust__item', ''],
        ['.luxury-category', 'm-reveal--zoom'],
        ['.luxury-story__content > *', ''],
        ['.luxury-signature__content > *', ''],
        ['.luxury-story__media', 'm-reveal--zoom'],
        ['.luxury-signature__media', 'm-reveal--zoom'],
        ['.luxury-testimonial', ''],
        ['.luxury-lookbook__tile', 'm-reveal--zoom'],
        ['.card-wrapper', ''],
        ['.grid__item', ''],
        ['.banner__box', '']
      ];
      var seen = [];
      revealTargets.forEach(function (pair) {
        var nodes = document.querySelectorAll(pair[0]);
        Array.prototype.forEach.call(nodes, function (el) {
          if (seen.indexOf(el) !== -1) return;         // never double-tag
          if (el.closest('.hero-3d')) return;           // hero has its own intro
          seen.push(el);
          el.classList.add('m-reveal');
          if (pair[1]) el.classList.add(pair[1]);
        });
      });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            var el = en.target;
            // stagger siblings that enter together
            var sibs = el.parentNode ? el.parentNode.children : [el];
            var idx = Array.prototype.indexOf.call(sibs, el);
            var delay = (idx % 6) * 90;
            setTimeout(function () { el.classList.add('m-inview'); }, delay);
            io.unobserve(el);
          });
        }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
        seen.forEach(function (el) { io.observe(el); });
      } else {
        seen.forEach(function (el) { el.classList.add('m-inview'); });
      }

      /* ---------- 3) Announcement marquee ---------- */
      var track = document.querySelector('.luxury-announcement__track');
      if (track && track.children.length) {
        var items = Array.prototype.slice.call(track.children);
        // Need enough content to loop seamlessly; clone the set at least once.
        var clone = function () {
          items.forEach(function (it) { track.appendChild(it.cloneNode(true)); });
        };
        clone();
        // If still short (very few items), clone again for a fuller ribbon.
        if (items.length < 3) clone();
        track.classList.add('m-marquee');
      }
    });
  } catch (e) {
    /* Fail silent: leave the page exactly as it was. */
    if (window.console && console.warn) console.warn('[mobile-experience] disabled:', e);
  }
})();
